import { Button, Modal } from 'antd';
import React from 'react';
import s from './s.module.less';

type Props = {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

enum ESendReminderType {
    SMS = 'TEXT',
    EMAIL = 'EMAIL',
    PORTAL_ALERT = 'PORTAL_ALERT',
}

//not same ui with antd
const SendReminderModal = (props: Props) => {
    const { open, onCancel, onConfirm } = props;
    const [selectedSendReminderType, setSelectedSendReminderType] = React.useState<ESendReminderType[]>([ESendReminderType.SMS, ESendReminderType.EMAIL, ESendReminderType.PORTAL_ALERT]);

    const handleOk = async () => {
        onConfirm?.();
    };

    return (
        <div>
            <Modal
                open={open}
                title="Send a reminder"
                width={660}
                className={s.modalFixHeightWrap}
                onCancel={() => {
                    onCancel?.();
                }}
                onOk={handleOk}
                okText="Send"
            >
                <div className={s.wrap}>
                    <div className={s.label}>Your patient hasn’t joined the visit yet. Would you like to send a quick reminder?</div>
                    <div className={s.list}>
                        <div
                            onClick={() => {
                                const selected = selectedSendReminderType.includes(ESendReminderType.SMS);
                                if (selectedSendReminderType.length === 1 && selected) {
                                    return;
                                }
                                if (selected) {
                                    setSelectedSendReminderType(selectedSendReminderType.filter((type) => type !== ESendReminderType.SMS));
                                } else {
                                    setSelectedSendReminderType([...selectedSendReminderType, ESendReminderType.SMS]);
                                }
                            }}
                            className={`${s.listItem} ${selectedSendReminderType.includes(ESendReminderType.SMS) ? s.listItemSelect : ''}`}
                        >
                            <div className={s.left}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M8 10H8.01M12 10H12.01M16 10H16.01M9 16H5C3.89543 16 3 15.1046 3 14V6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V14C21 15.1046 20.1046 16 19 16H14L9 21V16Z" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Text (SMS)
                            </div>
                            <div className={s.right}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9999 21.6004C17.3018 21.6004 21.5999 17.3023 21.5999 12.0004C21.5999 6.69846 17.3018 2.40039 11.9999 2.40039C6.69797 2.40039 2.3999 6.69846 2.3999 12.0004C2.3999 17.3023 6.69797 21.6004 11.9999 21.6004ZM16.4484 10.4489C16.9171 9.98029 16.9171 9.22049 16.4484 8.75186C15.9798 8.28323 15.22 8.28323 14.7514 8.75186L10.7999 12.7033L9.24843 11.1519C8.7798 10.6832 8.02 10.6832 7.55137 11.1519C7.08274 11.6205 7.08274 12.3803 7.55137 12.8489L9.95137 15.2489C10.42 15.7175 11.1798 15.7175 11.6484 15.2489L16.4484 10.4489Z" fill="#0E62F4" />
                                </svg>
                            </div>
                        </div>
                        <div
                            onClick={() => {
                                const selected = selectedSendReminderType.includes(ESendReminderType.EMAIL);
                                if (selectedSendReminderType.length === 1 && selected) {
                                    return;
                                }
                                if (selected) {
                                    setSelectedSendReminderType(selectedSendReminderType.filter((type) => type !== ESendReminderType.EMAIL));
                                } else {
                                    setSelectedSendReminderType([...selectedSendReminderType, ESendReminderType.EMAIL]);
                                }
                            }}
                            className={`${s.listItem} ${selectedSendReminderType.includes(ESendReminderType.EMAIL) ? s.listItemSelect : ''}`}
                        >
                            <div className={s.left}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M3 8L10.8906 13.2604C11.5624 13.7083 12.4376 13.7083 13.1094 13.2604L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Email
                            </div>
                            <div className={s.right}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9999 21.6004C17.3018 21.6004 21.5999 17.3023 21.5999 12.0004C21.5999 6.69846 17.3018 2.40039 11.9999 2.40039C6.69797 2.40039 2.3999 6.69846 2.3999 12.0004C2.3999 17.3023 6.69797 21.6004 11.9999 21.6004ZM16.4484 10.4489C16.9171 9.98029 16.9171 9.22049 16.4484 8.75186C15.9798 8.28323 15.22 8.28323 14.7514 8.75186L10.7999 12.7033L9.24843 11.1519C8.7798 10.6832 8.02 10.6832 7.55137 11.1519C7.08274 11.6205 7.08274 12.3803 7.55137 12.8489L9.95137 15.2489C10.42 15.7175 11.1798 15.7175 11.6484 15.2489L16.4484 10.4489Z" fill="#0E62F4" />
                                </svg>
                            </div>
                        </div>
                        <div
                            onClick={() => {
                                const selected = selectedSendReminderType.includes(ESendReminderType.PORTAL_ALERT);
                                if (selectedSendReminderType.length === 1 && selected) {
                                    return;
                                }
                                if (selected) {
                                    setSelectedSendReminderType(selectedSendReminderType.filter((type) => type !== ESendReminderType.PORTAL_ALERT));
                                } else {
                                    setSelectedSendReminderType([...selectedSendReminderType, ESendReminderType.PORTAL_ALERT]);
                                }
                            }}
                            className={`${s.listItem} ${selectedSendReminderType.includes(ESendReminderType.PORTAL_ALERT) ? s.listItemSelect : ''}`}
                        >
                            <div className={s.left}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9" stroke="#111827" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                Portal alert
                            </div>
                            <div className={s.right}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.9999 21.6004C17.3018 21.6004 21.5999 17.3023 21.5999 12.0004C21.5999 6.69846 17.3018 2.40039 11.9999 2.40039C6.69797 2.40039 2.3999 6.69846 2.3999 12.0004C2.3999 17.3023 6.69797 21.6004 11.9999 21.6004ZM16.4484 10.4489C16.9171 9.98029 16.9171 9.22049 16.4484 8.75186C15.9798 8.28323 15.22 8.28323 14.7514 8.75186L10.7999 12.7033L9.24843 11.1519C8.7798 10.6832 8.02 10.6832 7.55137 11.1519C7.08274 11.6205 7.08274 12.3803 7.55137 12.8489L9.95137 15.2489C10.42 15.7175 11.1798 15.7175 11.6484 15.2489L16.4484 10.4489Z" fill="#0E62F4" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SendReminderModal;
